import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import { Button } from "react-bootstrap";
import Calendar from "react-calendar/dist/umd/Calendar";
import { connect } from "react-redux";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
  setReportAssetId,
  setReportCalendatDate,
  setReportAssetName,
  setReportGroupId,
} from "../../../reducers/actions";
import LocationTable from "./locationTable";
import moment from "moment";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import queryString from "query-string";
import Select from "react-select";
import GridLoader from "react-spinners/GridLoader";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import GroupWarning from "../../commoncomponents/groupWarning";

const REPORT_FILTERING_STORAGE_KEY = "reportUseFiltering";

const getSavedReportFilteringState = () => {
  const savedValue = localStorage.getItem(REPORT_FILTERING_STORAGE_KEY);
  return savedValue === null ? true : savedValue !== "false";
};

class LocationData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: moment().format("dddd Do MMMM, YYYY"),
      groupCustomerName: "",
      groupGeneralName: "",
      assetName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      selectedDate: moment().format("YYYY-MM-DD"),
      date: new Date(),
      calendarSelectedDate: new Date(),
      calendarShow: false,
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      locationData: [],
      assetLoader: false,
      reportLoader: false,
      assetSelectionBoolean: false,
      errorLoader: false,
      errorMessage: "",
      isLoading: false,
      isTempAEnabled: false,
      isTempBEnabled: false,
      isDriverIDEnabled: false,
      deviceType: "",
      loadedReportParams: null,
    };
    this.groupId = "";
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const searchDate = values.assetDate || values.SearchDate || values.searchDate;
    const assetId = values.assetId || values.AssetId || values.id;
    const assetName = values.assetName || values.AssetName || values.name || "Selected Asset";
    const groupId = values.groupId || values.GroupId;
    const urlState = {};

    if (groupId) {
      this.groupId = groupId;
      urlState.groupId = groupId;
      urlState.assetLoader = true;
      this.props.setReportGroupIdAction(groupId);
      this.getAssets(groupId);
    }

    if (assetId) {
      if (searchDate !== undefined && searchDate !== "null") {
        urlState.dataPlaceholder = moment(searchDate).format("dddd Do MMMM, YYYY");
        urlState.selectedDate = searchDate;
        urlState.date = moment(searchDate).toDate();
        urlState.calendarSelectedDate = moment(searchDate).toDate();
      }

      urlState.assetPlaceholder = assetName;
      urlState.assetName = assetName;
      urlState.assetCustomerName = assetName;
      urlState.assetId = assetId;
      this.setState(urlState, this.handleCreateReport);
    } else if (Object.keys(urlState).length > 0) {
      this.setState(urlState);
    }

    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (GroupList.status === 200) {
        this.setState({ isLoading: false, groupDetails: GroupList.data });
      } else {
        this.setState({ isLoading: true });
      }
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }

    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  getAssets = async (groupId) => {
    try {
      let AssetList = await axios.get(`${apiHost}/api/Notification/AssetsByGroupId/${groupId || this.groupId}?IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });
    } catch (e) {
      console.warn("Report request failed");
      this.setState({ assetLoader: false });
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.setState({
        groupId: "",
        groupCustomerName: "",
        groupGeneralName: "",
        assetName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
        assetId: "",
        AssetList: [],
        assetLoader: false,
      });
      this.props.setReportGroupIdAction("");
      return;
    }

    const group = selectedGroup.data;
    this.groupId = group.groupId;
    this.setState({
      groupId: group.groupId,
      groupCustomerName: group.customername,
      groupGeneralName: group.groupName,
      assetName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      assetPlaceholder: "Select Asset",
      assetId: "",
      AssetList: [],
      assetLoader: true,
    });
    this.props.setReportGroupIdAction(group.groupId);
    this.getAssets(group.groupId);
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
      });
      return;
    }

    const asset = selectedAsset.data;
    this.setState({
      assetId: asset.assetId,
      assetName: asset.name,
      assetCustomerName: asset.name,
      assetGeneralName: asset.customerName,
      assetPlaceholder: asset.name,
    });
  };

  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };

  onChangeDate = (date) => {
    this.setState({
      date,
      calendarSelectedDate: date,
      selectedDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  getQuickReportUrl = (path) => {
    const assetName = this.state.assetName || this.state.assetCustomerName || this.state.assetPlaceholder || "";
    const params = new URLSearchParams({
      assetId: this.state.assetId,
      assetName,
      SearchDate: this.state.selectedDate,
      assetDate: this.state.selectedDate,
      UseFiltering: String(getSavedReportFilteringState()),
    });

    if (this.state.groupId) {
      params.set("groupId", this.state.groupId);
    }

    return `${path}?${params.toString()}`;
  };

  openQuickReport = (path) => {
    if (!this.state.assetId) {
      return;
    }

    const href = this.getQuickReportUrl(path);
    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = parentWindow.open(href, "_blank");

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  updateCurrentReportUrl = () => {
    const href = this.getQuickReportUrl(this.props.location.pathname);
    this.props.history.replace(href);
  };

  handleCreateReport = async () => {
    if (!this.state.assetId) {
      this.setState({
        assetSelectionBoolean: false,
        errorLoader: true,
        reportLoader: false,
        errorMessage: "Select an asset before creating the Location Data report.",
      });
      return;
    }

    this.setState({
      locationData: [],
      assetSelectionBoolean: true,
      reportLoader: true,
      errorLoader: false,
      errorMessage: "",
    });

    this.props.setReportAssetIdAction(this.state.assetId);
    this.props.setReportAssetNameAction(this.state.assetName || this.state.assetCustomerName);
    this.props.setReportCalendatDateAction(this.state.selectedDate);
    this.props.setReportGroupIdAction(this.state.groupId);
    this.updateCurrentReportUrl();
    this.setState({
      loadedReportParams: {
        assetId: this.state.assetId,
        selectedDate: this.state.selectedDate,
        groupId: this.state.groupId,
      },
    });

    try {
      let locationData = await axios.post(
        `${apiHost}/api/Report/LocationDataReport`,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.selectedDate || moment().format("YYYY-MM-DD"),
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: getSavedReportFilteringState(),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        locationData: locationData.data.locationData || [],
        isTempAEnabled: locationData.data.tempA,
        isTempBEnabled: locationData.data.tempB,
        isDriverIDEnabled: locationData.data.driverID,
        isDoorSensorEnabled: locationData.data.doorSensor,
        deviceType: locationData.data.deviceType || "",
        reportLoader: false,
        errorLoader: false,
      });
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.setState({
          errorLoader: true,
          errorMessage: `${e}`,
        });
        this.props.setErrorMessageAction(`${e}`);
      }
      this.setState({ reportLoader: false });
    }
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        backgroundColor: "#dbe4ef",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#7e8da1",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) || null;

    const assetOptions = this.state.AssetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));

    const selectedAssetOption =
      assetOptions.find((option) => option.value == this.state.assetId) ||
      (this.state.assetId
        ? {
            value: this.state.assetId,
            label: this.state.assetPlaceholder,
            data: {
              assetId: this.state.assetId,
              name: this.state.assetPlaceholder,
              customerName: this.state.assetGeneralName,
            },
          }
        : null);
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      this.state.assetId &&
      (
        loadedReportParams.assetId !== this.state.assetId ||
        loadedReportParams.selectedDate !== this.state.selectedDate ||
        (loadedReportParams.groupId || "") !== (this.state.groupId || "")
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div ref={this.setWrapperRef} className="ParentCalender" style={{ position: "relative", zIndex: 100 }}>
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar maxDate={new Date()} onChange={this.onChangeDate} value={this.state.calendarSelectedDate} />
        </div>
      </div>
    ) : (
      ""
    );

    return (
      <Layout>
        <Helmet>
          <title>Location Data</title>
        </Helmet>
        <div className="contentBody">
          <div className={!this.props.headerHide ? `contentWrapper contentWrapperSmoothRelease report-modern-page location-report-page` : `contentWrapper contentWrapperSmooth report-modern-page location-report-page`}>
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">Location Data Report</h2>
                  <p>Review raw location, telemetry and sensor data for a selected asset and day.</p>
                </div>
                <i className={this.props.headerHide ? `fa fa-window-restore` : `fa fa-window-maximize`} onClick={this.handleWindow} />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="reportQuickActions">
                  <span className="reportQuickActionsLabel">Quick reports</span>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-MVTL")}>MVTL</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-Visit")}>Visit</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Temperature")}>Temp</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Replay")}>Replay</button>
                  <button type="button" className="active" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-LocationData")}>Location</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Timeline")}>Timeline</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Track")}>Track</button>
                </div>
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId != ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  {this.state.assetId != "" ? (
                    <Button className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"} variant="primary" onClick={this.handleCreateReport} size="sm">
                      <i className="fa fa-map-marker"></i>
                      Create Report
                    </Button>
                  ) : (
                    <Button className="reportPickerCreateButton" variant="primary" onClick={this.handleCreateReport} size="sm" disabled>
                      <i className="fa fa-map-marker"></i>
                      Create Report
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            <div className="reportBody">
              {this.state.reportLoader ? (
                <div className="loaderLine">
                  <br /> <GridLoader size={7} color={"#222222"} loading={this.state.reportLoader} />
                  <h1> &nbsp;Generating Report</h1>
                  <br />
                </div>
              ) : this.state.errorLoader ? (
                <AssetInforWarning warningText={true} warningTextMsg={this.state.errorMessage || "No Data Available"} />
              ) : this.state.assetSelectionBoolean ? (
                <LocationTable
                  locationData={this.state.locationData}
                  assetId={this.state.assetId}
                  assetCustomerName={this.state.assetName}
                  timeZone={this.state.date}
                  tempAEnabled={this.state.isTempAEnabled}
                  tempBEnabled={this.state.isTempBEnabled}
                  driverIDEnabled={this.state.isDriverIDEnabled}
                  doorSensorEnabled={this.state.isDoorSensorEnabled}
                  deviceType={this.state.deviceType}
                />
              ) : (
                <AssetInforWarning />
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  headerHide: state.headerHide,
});

const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setReportAssetNameAction: setReportAssetName,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportGroupIdAction: setReportGroupId,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationData);
